// extracted by mini-css-extract-plugin
export default {"problem":"Loading_problem__LkvAk","problem-icon":"Loading_problem-icon__9VH58","problem__title":"Loading_problem__title__i9-q6"};